export default __webpack_public_path__ + "static/media/job_offer18_l.36edcbe1.jpg";